const consentGranted = group => typeof OptanonActiveGroups === 'undefined' ? false : OptanonActiveGroups.includes(group);

module.exports = {
	consentGranted,
};
